import React from "react"
import styled from "styled-components"
import { chunk, sum } from "lodash"
import { Box } from "rebass"

import GridItem from "./gridItem"

const Wrapper = styled(Box)`
  display: inline-block;
  overflow: hidden;
  /* Remove descenders gap below inline images */
  vertical-align: middle;
`

const Masonry = ({ items, itemsPerRow: itemsPerRowByBreakpoints }) => {
  const aspectRatios = items.map(item => item.image.aspectRatio)

  // For each breakpoint, calculate the aspect ratio sum of each row's images
  const rowAspectRatioSumsByBreakpoints = itemsPerRowByBreakpoints.map(
    itemsPerRow =>
      // Split images into groups of the given size
      chunk(aspectRatios, itemsPerRow).map(rowAspectRatios =>
        // Sum aspect ratios of images in the given row
        sum(rowAspectRatios)
      )
  )

  return (
    <div>
      {items.map(({ image }, i) => (
        <Wrapper
          key={i}
          width={rowAspectRatioSumsByBreakpoints.map(
            // Return a value for each breakpoint
            (rowAspectRatioSums, j) => {
              // Find out which row the image is in and get its aspect ratio sum
              const rowIndex = Math.floor(i / itemsPerRowByBreakpoints[j])
              const rowAspectRatioSum = rowAspectRatioSums[rowIndex]

              return `${(image.aspectRatio / rowAspectRatioSum) * 100}%`
            }
          )}
        >
          <a href={items[i].publicURL}>
            <GridItem image={image} altName={items[i].name} />
          </a>
        </Wrapper>
      
        
      ))}
    
    </div>
  )
}

export default Masonry
